"use client";

import React from "react";
import type { PageParent } from "./page-parent";
import { PageTitleContext } from "./page-title-context";

type PageTitleProviderProps = {
  title?: string;
  parents?: PageParent[];
  children: React.ReactNode;
};

export default function PageTitleProvider({ title, parents = [], children }: PageTitleProviderProps) {
  const value = React.useMemo(() => ({ title, parents }), [title, parents]);

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}
